import { useNavigate } from 'react-router-dom';

import { TableRow, TableCell } from '@occc-app/design-system';
import { RetailerNetworkLocationGroupForMemberFragment } from '@occc/graphql';
import { routeCreator } from '@occc/feat-retailer-connect';

import { mapRoleTypeToLabel } from '../constants';

type RetailerNetworkLocationGroupsForMemberRowProps = {
  locationGroup: RetailerNetworkLocationGroupForMemberFragment;
};

export const RetailerNetworkLocationGroupsForMemberRow = ({
  locationGroup,
}: RetailerNetworkLocationGroupsForMemberRowProps) => {
  const navigate = useNavigate();
  const onTableRowClick = () =>
    navigate(
      routeCreator.locationGroupDetails(locationGroup.retailerNetworkUuid, locationGroup.uuid),
    );

  return (
    <TableRow onClick={onTableRowClick}>
      <TableCell>{locationGroup.name}</TableCell>
      <TableCell>{locationGroup.countOfLocations}</TableCell>
      <TableCell>
        {locationGroup.roles
          ? locationGroup.roles.map((role) => mapRoleTypeToLabel[role]).join(', ')
          : ''}
      </TableCell>
    </TableRow>
  );
};
